import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  lebel: {
    color: theme.variables.allBlue,
    fontSize: theme.variables.fontSizeMd,
    margin: '0 0 4px 0',
    minHeight: '23px',
    [theme.breakpoints.down(1024)]:{
      fontSize:theme.variables.fontSizeSm,
    }
  },
  errorMessage: {
    color: '#ff1744',
    fontSize: theme.variables.fontSizeSm,
  },
}))

export default useStyles
